module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-3-d12f97c4ceb83b61807fdbc43ed4afc0.webp";